module.exports = __webpack_public_path__ + "img/fig14.044fb534.jpg";